import type { State } from '../../types';
import { joinWithAnd } from '../../../utilities/text';

import { employeesShortNamesAndI } from './employees-short-names-and-i';

export function employeeShortNamesAndIAsText(employees: string[], state: State): string {
  const names: string[] = employeesShortNamesAndI(state)
    .filter((e) => {
      return employees.includes(e.uuid);
    })
    .map((e) => {
      return e.name;
    });
  return joinWithAnd(names);
}
